import React, { useEffect, createRef } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Login from "pages/login/Login";
import { useSelector } from "react-redux";
import { showToast } from "../services/helper";
import Terms from "pages/terms/Terms";
import ContentMigration from "pages/contentMigration/ContentMigration";
import GroupsPerfomance from "pages/groupsPerfomance/GroupsPerfomance";
import UrlGroupDetails from "pages/urlGroupDetails/UrlGroupDetails";
import TermForm from "pages/termDetails/TermForm";
import ChangePassword from "pages/changePassword/ChangePassword";
import Users from "pages/users/Index";
import Notes from "pages/notes/Index";
import UserForm from "pages/users/UserForm";
import NoteForm from "pages/notes/NoteForm";
import { Home } from "pages/home/Index";
import { RecoveryPassword } from "pages/recoveryPassword/Index";

export const navigateRef = createRef();

function RoutesContainer() {
  const navigate = useNavigate();
  navigateRef.current = navigate;

  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route exact path="/groups-performance" element={<GroupsPerfomance />} />
      <Route exact path="/terms" element={<Terms />} />
      <Route exact path="/users" element={<Users />} />
      <Route exact path="/notes" element={<Notes />} />
      <Route exact path="/content-migration" element={<ContentMigration />} />
      <Route exact path="/term/:id" element={<TermForm />} />
      <Route exact path="/term" element={<TermForm />} />
      <Route exact path="/login" element={<Login />} />
      <Route exact path="/change-password" element={<ChangePassword />} />
      <Route exact path="/recovery-password" element={<RecoveryPassword />} />
      <Route exact path="/user" element={<UserForm />} />
      <Route exact path="/user/:id" element={<UserForm />} />
      <Route exact path="/note" element={<NoteForm />} />
      <Route exact path="/note/:id" element={<NoteForm />} />
      <Route
        exact
        path="/url-group-details/:groupId"
        element={<UrlGroupDetails />}
      />
      <Route path="*" element={<CustomNavigate />} />
    </Routes>
  );
}

export default RoutesContainer;

function CustomNavigate() {
  //REDUX
  const userToken = useSelector((state) => state?.user?.token);
  //OTHERS
  const userIsLogged = userToken?.length > 0;

  useEffect(() => showToast("Página não encontrada.", "error"), []);
  return <Navigate to={userIsLogged ? "/groups-performance" : "/login"} />;
}
